// import { FiBell } from "react-icons/fi";
import "react-calendar/dist/Calendar.css";
import { VscBell } from "react-icons/vsc";
import DropdownCalendar from "../DropdownCalendar/DropdownCalendar";
import styles from "./HeaderBar.module.css";

function HeaderBar() {
  return (
    <>
      {/* <div className={styles.headerContainer}>
        <span>
          <svg
            width="12"
            height="10"
            viewBox="0 0 12 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.75 9.25H11.25M0.75 5.25H11.25M0.75 1.25H11.25"
              stroke="black"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </span>

        <input
          type="text"
          className={styles.searchInput}
          placeholder="Search..."
        />

        <div className={styles.profile}>
          <VscBell className={styles.bell} />
          <img
            src="/profile.jpg"
            alt="Profile"
            className={styles.profileIcon}
          />
        </div>
      </div> */}

      <div className={styles.calender}>
        <DropdownCalendar />
      </div>
    </>
  );
}

export default HeaderBar;
